import { apiErrorStatus } from './errors';

/** React Query's own default. */
const MAX_RETRIES = 3;

/** Statuses in the 4xx range that can pass on their own: a timeout and a rate limit. */
const TRANSIENT_CLIENT_STATUSES = new Set([408, 429]);

/**
 * The retry rule for every query: a refused request (4xx) is final, so it fails at once instead
 * of after three backed-off retries, which kept a page loading for seconds before it could say
 * "not found" or "no access". A server failure, a lost connection or a timeout is retried as
 * React Query does by default.
 */
export function retryUnlessRefused(failureCount: number, error: unknown): boolean {
    const status = apiErrorStatus(error);
    const refused =
        status !== undefined &&
        status >= 400 &&
        status < 500 &&
        !TRANSIENT_CLIENT_STATUSES.has(status);
    return !refused && failureCount < MAX_RETRIES;
}
